module.exports = __webpack_public_path__ + "M27.png?0faa806efb42d469f610ffcb1297fa4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M27.png
// module id = 299
// module chunks = 0